/**
 * The HOC is used to calculate total values
 * @author: Ronan
 * @param: sourceProp {string} prop that needs to be processed.
 * @param: targetProp {string} prop that passed to WrappedComponent
 */
import React, { PureComponent } from 'react';
import { toFixedDecimal } from 'utils/mathUtil';
import Enums from 'utils/EnumsManager';

const { AGGREGATES } = Enums.DROPZONES;
const { MAXROWS, SUMMARYKEY, GROUPROWKEY, TOTALROWKEY } = Enums.REPORTS.PREVIEW;


const appendTotalRow = (sourceProp, targetProp) => WrappedComponent => class extends PureComponent {
  getAggregateColumns = () => this.props.usedColumns.filter(uCol => uCol.belongTo === AGGREGATES)
  getNonGroupRows = () => this.props[sourceProp].filter(row => !row[GROUPROWKEY])
  renderTotalRow = () => {
    const aggColumns = this.getAggregateColumns();
    const nonGroupRows = this.getNonGroupRows();
    // get total sum for each aggregate col with all groups
    const data = aggColumns.map((aCol) => {
      let sum = nonGroupRows.reduce((acc, row) => acc + Number(row[aCol.name]), 0);
      return {
        id: aCol.id,
        label: aCol.label,
        sum: aCol.actions.indexOf('sum') > -1 ? toFixedDecimal(sum) : null,
        avg: aCol.actions.indexOf('avg') > -1 ? toFixedDecimal(sum / MAXROWS) : null,
      };
    });
    return {
      [TOTALROWKEY]: true,
      [SUMMARYKEY]: {
        data,
        count: MAXROWS,
      },
    };
  }

  render() {
    const props = {
      ...this.props,
      [targetProp]: [
        ...this.props[sourceProp],
        this.renderTotalRow(),
      ],
    };
    return <WrappedComponent {...props} />;
  }
};

export default appendTotalRow;



// WEBPACK FOOTER //
// ./src/views/ReportPreview/HOCs/appendTotalRow.jsx